import Loading from '../loading/Loading'

import Layout from './Layout'

import { useTenant } from '@/hooks/useTenant'
import { useUser } from '@/hooks/useUser'

const RequireData = () => {
  const { user, isLoading: userLoading, isError: userError, error: userErrorObj } = useUser()
  const {
    tenant,
    isLoading: tenantLoading,
    isError: tenantError,
    error: tenantErrorObj,
    refetch,
  } = useTenant()

  const isLoading = userLoading || tenantLoading
  const hasError = tenantError || userError
  const isReady = !!user && !!tenant

  return (
    <Loading
      loading={isLoading || !isReady}
      label="Daten werden geladen..."
      showError={hasError}
      resetErrorBoundary={() => {
        // Refetch data on error
        refetch()
      }}
      error={tenantErrorObj || userErrorObj}
    >
      <Layout />
    </Loading>
  )
}

export default RequireData
